module.exports = __webpack_public_path__ + "img/tn-timeline-main-2.a39b0c52.jpg";